import {isUserPremium} from '@Libraries/user.library';
import {getPremiumUpsellIconClasses} from '@Libraries/premium-library';

export enum SocialMediaMobileFooterType {
  NAVIGATE_STEP = 'NAVIGATE_STEP',
  PUBLISH_STEP = 'PUBLISH_STEP',
  SCHEDULE_STEP = 'SCHEDULE_STEP',
}

export const getIconsByFooterType = (footerType: SocialMediaMobileFooterType): string[] => {
  if (footerType === SocialMediaMobileFooterType.NAVIGATE_STEP) {
    return [''];
  }

  if (footerType === SocialMediaMobileFooterType.SCHEDULE_STEP) {
    return ['icon-save', 'icon-send'];
  }

  let scheduleIcon = 'icon-calendar';

  if (!isUserPremium()) {
    scheduleIcon = getPremiumUpsellIconClasses();
  }

  return ['icon-save', scheduleIcon];
};

export const getOptionsTextByFooterType = (footerType: SocialMediaMobileFooterType): string[] => {
  if (footerType === SocialMediaMobileFooterType.NAVIGATE_STEP) {
    return [''];
  }

  if (footerType === SocialMediaMobileFooterType.SCHEDULE_STEP) {
    return [`${window.i18next.t('pmwjs_save_as_draft')}`, `${window.i18next.t('pmwjs_publish_right_now')}`];
  }

  return [`${window.i18next.t('pmwjs_save_as_draft')}`, `${window.i18next.t('pmwjs_schedule_for_later')}`];
};
